var bighouse = bighouse || {};

bighouse.backToTop = (function () {

    function init() {

        window.addEventListener("scroll", function(){ 
            var scrollTop = window.pageYOffset || document.documentElement.scrollTop; // Credits: "https://github.com/qeremy/so/blob/master/so.dom.js#L426"
            var docHeight = $(window).height();

            if(scrollTop > (docHeight/4)){
                $('.BackToTop').addClass('BackToTop--show');
            } else {
                $('.BackToTop').removeClass('BackToTop--show');
            }

        }, false);

    }


    return {
        init: init
    };
})();